import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useStyles } from '../styles';
import { DataTable } from '../../../shared/data-table';
import { selectBookingsHistory } from '../../../../store';
import { useAppConfiguration } from '../../../shared/hook';

export const BookingHistory: FC = () => {
  const { t } = useTranslation();
  const { bookings } = useSelector(selectBookingsHistory);
  const { withUnlimitedCredits } = useAppConfiguration();
  const classes = useStyles({ withUnlimitedCredits });

  let bookingHistoryColumns = [
    {
      field: 'offeringName',
      headerName: t(
        'v2.account.bookingHistory_card_label_eventName',
      ).toUpperCase(),
      width: 200,
    },
    {
      field: 'bookedAt',
      headerName: t('v2.account.bookingHistory_card_label_date').toUpperCase(),
      width: 200,
    },
    {
      field: 'offeringPrice',
      headerName: t('v2.account.bookingHistory_card_label_price').toUpperCase(),
      width: 200,
    },
    {
      field: 'offeringType',
      headerName: t(
        'v2.account.bookingHistory_card_label_offering',
      ).toUpperCase(),
      width: 200,
    },
  ];

  if (withUnlimitedCredits) {
    bookingHistoryColumns = bookingHistoryColumns.filter(
      (item) => item.field !== 'offeringPrice',
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      className={classes.itemWrapper}
    >
      <Box className={classes.titleContainer}>
        <Typography className={classes.title}>
          {t('v2.account.bookingHistory_card_label_title')}
        </Typography>
      </Box>
      <DataTable
        t={t}
        columns={bookingHistoryColumns}
        bookingHistoryList={bookings}
      />
      {bookings.length === 0 && (
        <Box className={classes.emptyState}>
          <Typography variant="body1" className={classes.emptyStateText}>
            {t('v2.account.bookingHistory_card_label_emptyState')}
          </Typography>
          <Button
            component={Link}
            variant="contained"
            color="primary"
            className={classes.cardButton}
            to="/"
          >
            {t('v2.account.bookingHistory_card_button_emptyState')}
          </Button>
        </Box>
      )}
    </Box>
  );
};
